// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type BenchmarkFormProps, type BenchmarkResult } from '../prospects/types'

type ResponseType = {
  data: BenchmarkResult[];
}

export function useCreateBenchmark ({
  prospectId,
  quoteId,
}: {
  prospectId: string;
  quoteId: string;
}) {
  return useMutation<ResponseType, GrapeAPIErrorType, BenchmarkFormProps>({
    mutationFn: async (data: BenchmarkFormProps) => {
      const request = new FetchRequest(
        'post',
        `/api/web/quoting/prospects/${prospectId}/quotes/${quoteId}/benchmarks`,
        {
          headers: {
            Accept: 'application/json',
          },
          body: data,
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
